import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isTouch, Basics } from '../_app/cuchillo/core/Basics';
import Popup from '../layout/Popup';

const INTERVAL = 4000;

class ScrollItem__BlockDiscoverySet extends ScrollItem__BlockDefault {
    _items = [];
    _nItems = 0;
    _current = 0;
    _timer = null;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._items = Array.from(GetBy.selector('.block-discovery-set__item', this.item));
        this._nItems = this._items.length;

        // El reveal del button-torcido el gestiona ja ScrollItem__BlockDefault (mesura
        // l'amplada natural abans de posar-la a 0). No el dupliquem aquí: si el mesuréssim
        // després de super() l'amplada ja seria 0 → finalW=0 → botó invisible.

        if (this._nItems > 0) {
            this._setCurrent(0);
            if (!isTouch) this._bindHover();
        }

        // CTA → obre el popup full-screen amb el contingut de text_popup (guardat al
        // <template> ocult). El text s'injecta cada cop que s'obre (Popup.open).
        const popupBtn = GetBy.selector('[data-popup]', this.item)[0];
        const popupTextEl = GetBy.class('block-discovery-set__popup-text', this.item)[0];
        if (popupBtn) {
            this._popupText = popupTextEl ? popupTextEl.innerHTML : '';
            popupBtn.addEventListener(Basics.clickEvent, () => Popup.open(this._popupText));
        }

        this.onHide = () => { if (!isTouch) this._stopTimer(); };
    }

    showCb() {
        super.showCb();
        if (!isTouch) this._startTimer();
    }

    _setCurrent(index) {
        this._current = index;
        for (let i = 0; i < this._nItems; i++) {
            this._items[i].classList.toggle('--is-current', i === index);
        }
    }

    _startTimer() {
        this._stopTimer();
        this._timer = setInterval(() => {
            this._setCurrent((this._current + 1) % this._nItems);
        }, INTERVAL);
    }

    _stopTimer() {
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }

    _bindHover() {
        this._items.forEach((el, i) => {
            el.addEventListener('mouseenter', () => {
                this._stopTimer();
                this._setCurrent(i);
            });
            el.addEventListener('mouseleave', () => {
                this._startTimer();
            });
        });
    }
}

Scroll._registerClass('BlockDiscoverySet', ScrollItem__BlockDiscoverySet);

export default ScrollItem__BlockDiscoverySet;
